// extracted by mini-css-extract-plugin
module.exports = {"cell":"SearchTableBodyCell_cell__KnPev"};